<template>
  <!--  预算编制-->
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed; top: 0; z-index: 999; width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
<!--    <van-tabs v-if="inputForm.contractCategory == 9 && inputForm.businessType" v-model="active" color="#409EFF">-->
<!--      <van-tab title="费控合同信息" name="1"></van-tab>-->
<!--      <van-tab title="业务信息" name="2"></van-tab>-->
<!--    </van-tabs>-->
    <van-collapse v-model="activeNames">
      <van-collapse-item title="合同基本信息" name="1">
        <van-field v-model="inputForm.contractCode" label="合同编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractName" label="合同名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.isSupplement === '1'" v-model="inputForm.mainContractName" label="主合同" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field :value="inputForm.isSupplement === '1' ? '是': '否'" label="是否补充合同" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractCategoryName" label="合同类别" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractTypeName" label="合同类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.budgetItemsName" label="所属项目" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractNatureName" label="合同性质" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractVersionName" label="合同版本" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractVersion === '1'" v-model="inputForm.contractTemplateName" label="合同模板" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyJiaName" label="合同甲方" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyYiSupplierName" label="合同乙方" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyYiContactsName" label="合同乙方联系人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractPartyYiContactsMobile" label="合同乙方联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractNature === '2'" v-model="inputForm.contractPartyBingSupplierName" label="合同丙方" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractNature === '2'" v-model="inputForm.contractPartyBingContactsName" label="合同丙方联系人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractNature === '2'" v-model="inputForm.contractPartyBingContactsMobile" label="合同丙方联系方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorName" label="经办人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptName" label="经办部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.operatorDeptHeadName" label="部门负责人" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field :value="inputForm.isUnitPrice === '1' ? '是': '否'" label="是否单价类" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '2'" v-model="inputForm.materialRequestTypeName" label="要料类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '3'" v-model="inputForm.mediumName" label="媒介" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
<!--        <van-field v-if="inputForm.contractCategory === '9'" v-model="inputForm.businessTypeLabel" label="业务类型" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />-->
      </van-collapse-item>
      <van-collapse-item title="合同价款信息" name="2" v-if="inputForm.contractCategory !== '4' && inputForm.isUnitPrice === '0'">
        <van-field v-if="inputForm.isSupplement === '1'" v-model="inputForm.contractSettlementAmount" label="主合同金额(元)" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractAmount" :label="inputForm.isSupplement === '1' ? '补充合同金额(元)' : '合同金额(元)'" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.isSupplement === '1'" v-model="inputForm.contractIncludeAmount" label="补充后合同金额(元)" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractBigAmount" :label="inputForm.isSupplement === '1' ? '补充合同大写金额' : '合同大写金额'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '1'" v-model="inputForm.jiaSupplierMaterialAmount" :label="inputForm.isSupplement === '1' ? '补充甲供材金额(元)' : '甲供材金额(元)'" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '1'" v-model="inputForm.jiaSupplierMaterialBigAmount" :label="inputForm.isSupplement === '0'?'甲供材大写金额':'补充甲供材大写金额'" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.isSupplement === '0'" v-model="inputForm.warrantyRatio" label="质保金比例(%)" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.warrantyAmount" :label="inputForm.isSupplement === '1' ? '补充质保金金额(元)' :'质保金金额(元)'" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '2'" v-model="inputForm.materialEquipmentAmount" :label="inputForm.isSupplement === '1' ? '补充材料设备金额(元)' : '材料设备金额(元)'" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '2'" v-model="inputForm.dutyRate" label="税率(%)" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '2'" v-model="inputForm.isIncludedService === '1' ? '是': '否'" label="是否含服务费" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.contractCategory === '2'" v-model="inputForm.serviceAmount" :label="inputForm.isSupplement === '1' ? '补充服务费金额(元)' : '服务费金额(元)'" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.isAdvancePayment === '1' ? '是': '否'" label="是否有预付款" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.isAdvancePayment === '1'" v-model="inputForm.advancePaymentAmount" label="预付款金额" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
      <van-collapse-item title="合同价款信息" name="2" v-if="inputForm.contractCategory === '4' || inputForm.isUnitPrice === '1'">
        <van-field v-model="inputForm.isAdvancePayment === '1' ? '是': '否'" label="是否有预付款" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.isAdvancePayment === '1'" v-model="inputForm.advancePaymentAmount" label="预付款金额" :formatter="formatterNumber" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div class="unitTitle">合同单价信息</div>
        <div class="m-form" v-for="(data, index) in inputForm.unitPriceList" :key="index">
          <div class="m-row">
            <div class="m-row-text">单价名称</div>
            <div class="m-row-content">{{ data.name }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">单位</div>
            <div class="m-row-content">{{ data.unit }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">单价/比例(%)</div>
            <div class="m-row-content">{{data.unitCategory === '3' ? '-' : data.unitCategory === '2' ? Number(data.unitPrice).toFixed(2) :  Number(data.unitPrice).toFixed(6) }}</div>
          </div>
          <div class="m-row">
            <div class="m-row-text">备注</div>
            <div class="m-row-content large-content">{{ data.remarks }}</div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="合同其他信息" name="3">
        <van-field v-model="inputForm.countersignApprovalNumber" label="会签审批单编号" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div v-show="inputForm.hqAttachList.length > 0" style="padding-left: 16px">
          <p>会签单附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.hqAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
        <van-field v-model="inputForm.placeOfSigning" label="合同签订地点" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractFormationWayName" label="形成方式" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.executorDeptNames" label="执行部门" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.contractDate" label="合同期限" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.contractCategory != 4" v-model="inputForm.warrantyDate" label="质保期限" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-show="inputForm.contractCategory != 4" v-model="inputForm.warrantyAgreement" label="质保约定" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remarks" label="备注" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div v-show="inputForm.generalAttachList.length > 0" style="padding-left: 16px">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.generalAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="付款计划" name="4" v-if="inputForm.contractCategory != 4 && inputForm.isUnitPrice === '0'">
        <van-field v-model="inputForm.budgetControlName" label="预算控制" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-if="inputForm.budgetControl === '2'" v-model="inputForm.specialBudgetItemsName" label="专项预算项目" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <div v-for="(data, index) in inputForm.paymentPlanList" :key="index" style="margin-bottom: 10px">
<!--          <div class="m-row">-->
<!--            <div class="m-row-text">序号</div>-->
<!--            <div class="m-row-content">{{ index }}</div>-->
<!--          </div>-->
          <div class="m-form">
            <div class="m-row" v-if="inputForm.budgetControl === '1'">
              <div class="m-row-text">预算年度</div>
              <div class="m-row-content">{{ data.adjustmentBudgetAnnualName }}</div>
            </div>
            <div class="m-row" v-if="inputForm.budgetControl === '1'">
              <div class="m-row-text">预算科目名称</div>
              <div class="m-row-content">{{ data.adjustmentBudgetSubjectFullName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">款项类型</div>
              <div class="m-row-content">{{ data.paymentType === '2' ? '进度款' : '质保金' }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">付款条件</div>
              <div class="m-row-content large-content">{{ data.paymentClause }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">应付时间</div>
              <div class="m-row-content">{{ data.planDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">资金计划时间</div>
              <div class="m-row-content">{{ data.fundsPlanDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">付款比例(%)</div>
              <div class="m-row-content">{{ Number(data.adjustmentPaymentRatio).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">金额(元)</div>
              <div class="m-row-content">{{ Number(data.adjustmentPlanAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">备注</div>
              <div class="m-row-content large-content">{{ data.remarks }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
      <van-collapse-item title="劳务费用完工结算清单" name="5" v-if="inputForm.isUnitPrice === '0' && inputForm.isSupplement === '0' && inputForm.contractCategory === '1' && inputForm.completionSettlementList.length > 0">
        <div v-for="(data, index) in inputForm.completionSettlementList" :key="index" style="margin-bottom: 10px">
          <div class="m-form">
            <div class="m-row">
              <div class="m-row-text">立项/报修事项</div>
              <div class="m-row-content large-content">{{ data.itemName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">立项/报修编号</div>
              <div class="m-row-content large-content">{{ data.itemCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">立项/报修日期</div>
              <div class="m-row-content">{{ data.itemDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">结账日期</div>
              <div class="m-row-content">{{ data.checkoutDate }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">结算单编号</div>
              <div class="m-row-content large-content">{{ data.settlementCode }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">劳务结算费用(元)</div>
              <div class="m-row-content">{{ Number(data.settlementAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">备注</div>
              <div class="m-row-content large-content">{{ data.contractRemarks }}</div>
            </div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
<!--    <div v-show="active === '2' && inputForm.contractCategory == 9 && inputForm.businessType">-->
<!--      <ItsContractPurchase v-if="inputForm.businessType === '101'" ref="itsContractPurchase" :businessId="inputForm.id"></ItsContractPurchase>-->
<!--      <ItsContractAgency  v-else-if="inputForm.businessType === '102'" ref="itsContractAgency" :businessId="inputForm.id"></ItsContractAgency>-->
<!--      <ItsContractRentCold v-else-if="inputForm.businessType === '103'" ref="itsContractRentCold" :businessId="inputForm.id"></ItsContractRentCold>-->
<!--      <ItsContractRentPack v-else-if="inputForm.businessType === '104'" ref="itsContractRentPack" :businessId="inputForm.id"></ItsContractRentPack>-->
<!--      <ItsContractCarrier v-else-if="inputForm.businessType === '110'" ref="itsContractCarrier" :businessId="inputForm.id"></ItsContractCarrier>-->
<!--    </div>-->
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../components/processRecord/processRecord";
import TaskService from "../../../../api/flowable/TaskService";
import ProcessService from "../../../../api/flowable/ProcessService";
import flowSettingService from '../../../../api/sys/flowSettingService'
import ItsContractAgency from "../../its/reg/contract/ItsContractAgency.vue";
import ItsContractPurchase from "../../its/reg/contract/ItsContractPurchase.vue";
import ItsContractRentPack from "../../its/reg/contract/ItsContractRentPack.vue";
import ItsContractRentCold from "../../its/reg/contract/ItsContractRentCold.vue";
import ItsContractCarrier from "../../its/reg/contract/ItsContractCarrier.vue";
import Decimal from "decimal.js";
import Vue from "vue";
import QueryInfoService from "@/api/system/queryInfoService";
export default {
  name: "contract",
  data(){
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      subjectTypeList: [],
      activeName: '',
      inputForm:{
        hqAttachList: [],
        generalAttachList: [],
        completionSettlementList: []
      },
      active: '1'
    }
  },
  components: {
    processRecord,
    ItsContractAgency,
    ItsContractPurchase,
    ItsContractRentPack,
    ItsContractRentCold,
    ItsContractCarrier
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {
        },
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.inputForm.id = id
      this.$flow.queryById(id, '/contract/costContractInfo/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate =  this.inputForm.createDate.slice(0,10)
        this.inputForm.executorDeptNames = data.executorDeptList.map(item => item.executorDeptName).join(',')
        if(data.contractDateStart && data.contractDateEnd) {
          this.inputForm.contractDate = data.contractDateStart  + '至' + data.contractDateEnd
        } else {
          this.inputForm.contractDate = ''
        }
        if (data.contractStatus === '1') {
          this.inputForm.warrantyRatio = Decimal(data.warrantyAmount).div(data.contractAmount).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
        }
        if(data.isSupplement === '1') {
          this.inputForm.mainContractName = data.mainContractCode + '-' + data.mainContractName
          this.inputForm.contractIncludeAmount = Decimal(data.contractAmount).add(data.contractSettlementAmount).toFixed(2, Decimal.ROUND_HALF_UP)
        }

        if(data.contractCategory == 4) {
          this.inputForm.unitPriceList.forEach(item => {
            if(item.unitCategory === '2') {
              item.unitPrice = Decimal(item.unitPrice).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
            }
          })
        }
        this.inputForm.warrantyBigAmount = this.numberToChinese(this.inputForm.warrantyAmount)
        this.inputForm.contractBigAmount = this.numberToChinese(this.inputForm.contractAmount)
        if(data.contractStatus === '1') {
          this.inputForm.jiaSupplierMaterialBigAmount = this.numberToChinese(this.inputForm.jiaSupplierMaterialAmount)
        }
        this.inputForm.contractSettlementAmount = data.contractSettlementAmount.toFixed(2)
        if(data.contractCategory == 1) {
          this.inputForm.effectiveContractBigAmount = this.numberToChinese(this.inputForm.effectiveContractAmount)
        }
        if(data.contractCategory == 9) {
          this.getDict([
            ['cost_contract_business_type', 'businessType'],
          ])
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts){
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item=>item.value==this.inputForm[formField]).label);
        });
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(async () => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        let sendBy = ''
        let sendByDeptId = ''
        let sendByCompanyId = ''
        if(this.inputForm.flowStatus === 1) {
          sendBy = Vue.cookie.get('userId');
          const res1 = await new flowSettingService().queryUser(sendBy)
          sendByDeptId = res1.data.officeDTO.id
          sendByCompanyId = res1.data.companyDTO.id
        } else {
          const res3 = await new TaskService().queryByProcInsId(this.inputForm.procInsId)
          sendBy = res3.data.createBy
          sendByDeptId = res3.data.createDept
          sendByCompanyId = res3.data.createCompany
        }
        let createByDeptId = ''
        let createByCompanyId = ''
        const res2 = await new flowSettingService().queryUser(this.inputForm.createById)
        createByDeptId = res2.data.officeDTO.id
        createByCompanyId = res2.data.companyDTO.id
        // vars = { ...vars, ..._this.inputForm }
        vars = {
          sendBy: sendBy,
          sendByDeptId: sendByDeptId,
          sendByCompanyId: sendByCompanyId,
          createByDeptId: createByDeptId,
          createByCompanyId: createByCompanyId,
          createBy: this.inputForm.createById,
          contractCategory: this.inputForm.contractCategory,
          operatorId: this.inputForm.operatorId,
          operatorDeptId: this.inputForm.operatorDeptId,
          paymentCompanyId: this.inputForm.contractPartyJiaId
        }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/contract/costContractInfo/startFlow').then(() => {
            if(this.inputForm.contractCategory == 9 && this.inputForm.businessType) {
              _this.$flow.startFlow2(form, '/its/contract/cost/startFlow')
            }
          })

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey
          }
          _this.$flow.startFlow(form, '/contract/costContractInfo/startFlow').then(() => {
            if(this.inputForm.contractCategory == 9 && this.inputForm.businessType) {
              _this.$flow.startFlow2(form, '/its/contract/cost/startFlow')
            }
          })

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatterNumber(value){
      return Number(value).toFixed(2)
    },
    formatterYN(value){
      return value === '1'? '是' : '否'
    },
    // 将数字转为大写
    numberToChinese(Amount) {
      if (Amount === 0) {
        return '零圆'
      }
      let amount = Math.abs(Amount)
      let tempAmount = ''
      if (amount !== '' && amount != null && amount !== '0') {
        let unit = '仟佰拾亿仟佰拾万仟佰拾圆角分'
        let str = ''
        amount += '00'
        const point = amount.indexOf('.')
        if (point >= 0) {
          amount = amount.substring(0, point) + amount.substr(point + 1, 2)
        }
        unit = unit.substr(unit.length - amount.length)
        for (let i = 0; i < amount.length; i++) {
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(amount.charAt(i)) + unit.charAt(i)
        }
        tempAmount = str.replace(/零(仟|佰|拾|角)/g, '零')
            .replace(/(零)+/g, '零')
            .replace(/零(万|亿|圆)/g, '$1')
            .replace(/(亿)万|(拾)/g, '$1$2')
            .replace(/^圆零?|零分/g, '')
            .replace(/元$/g, '圆');
      }
      if (Amount < 0) {
        tempAmount = '负' + tempAmount
      }
      return tempAmount;
    },
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.m-form {
  width: 100%;
  /*padding: 10px;*/
  font-size: 12px;
  box-sizing: border-box;
  /*border-bottom: 1px solid #eee;*/
  padding-left: 16px;
  margin-bottom: 10px;
}
.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
  /*// margin-bottom: 20rpx;*/
}

.m-row {
  display: flex;
  width: calc(100%);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row:last-child {
  border-bottom: 1px solid #eee;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #dedede;*/
}

.m-row-content {
  width: calc(100% - 110px);
  color: black;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100% - 110px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>
